/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneConfirmSheet.tsx
 * FILE_ID: JOBHUB-QA-PHONE-CONFIRM-001
 * PURPOSE: Yes/No sheet so phone never relies on window.confirm.
 */
import { useState } from 'react'
import { MobileSheet } from '@quotech/ui'

export function QaPhoneConfirmSheet({
  open,
  onClose,
  title,
  body,
  confirmLabel,
  onConfirm,
}: {
  open: boolean
  onClose: () => void
  title: string
  body: string
  confirmLabel: string
  onConfirm: () => void | boolean | Promise<void | boolean>
}) {
  const [busy, setBusy] = useState(false)
  return (
    <MobileSheet
      open={open}
      onClose={onClose}
      title={title}
      footer={(
        <div className="flex gap-2">
          <button type="button" onClick={onClose} className="min-h-[44px] flex-1 rounded-lg border border-border text-sm">
            Cancel
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={() => {
              void (async () => {
                setBusy(true)
                try {
                  const close = await onConfirm()
                  if (close !== false) onClose()
                } finally {
                  setBusy(false)
                }
              })()
            }}
            className="min-h-[44px] flex-1 rounded-lg bg-primary text-sm font-semibold text-primary-foreground"
          >
            {confirmLabel}
          </button>
        </div>
      )}
    >
      <p className="px-4 py-3 text-sm text-foreground">{body}</p>
    </MobileSheet>
  )
}
